import React, { Component } from 'react';

import Logo from '../../assets/images/logo_footer.png';


class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="footer_main">
                    <div className="container">
                        <div className="footerinner">
                            <div className="row">
                                <div className="col-sm-5">
                                </div>
                                <div className="col-sm-3">
                                    <div className="second_box">
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="third_box">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer_but clearfix">
                            <div className="social_icons">
                                <a href="#"><i className="fab fa-facebook-f"></i></a>
                                <a href="#"><i className="fab fa-linkedin-in"></i></a>
                                <a href="#"><i className="fab fa-twitter"></i></a>
                                <a href="#"><i className="fab fa-google-plus-g"></i></a>
                            </div>
                            <div className="copytext">©2018 Wewhodo. All rights reserved.</div>

                        </div>
                    </div>

                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js